// extracted by mini-css-extract-plugin
export default {"wrapper":"LogInCard_wrapper__sN4mW","title":"LogInCard_title__vA8QU","regularTitle":"LogInCard_regularTitle__tIzn8"};